import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { hasActiveSession } from "@/lib/auth";
import { saveRedirect } from "@/lib/storage-utils";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute("/audiolab")({
  component: RouteComponent,
  head: () => noindexHead("Audiolab | Lutely"),
  beforeLoad: async ({ location }) => {
    const isAuthenticated = await hasActiveSession(); // todo handle stale pool state
    if (!isAuthenticated) {
      saveRedirect(location.href);
      throw redirect({
        to: "/",
        search: { auth: "login" as const },
      });
    }
  },
});

function RouteComponent() {
  return <Outlet />;
}
